import {
  addItemToCollection,
  fetchUser,
  getItemsFromCollection,
} from "directus/src/operations";
import { getDirectusField } from "directus/src/operations";
import { getItemFromCollection } from "directus/src/operations";
import { filter } from "lodash";

export async function fetchProjectStatuses() {
  try {
    const response = await getDirectusField("projects", "status");

    const data = response.meta.options.choices.map((status) => {
      return { name: status.text, id: status.value };
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchProjectBySlug(id) {
  try {
    const query = {
      fields: ["id", "coordinator", "sales_coordinator"],
    };
    const response = await getItemFromCollection("projects", id, query);
    return response;
  } catch (error) {
    console.error("Error fetching project coordinators:", error);
    throw error;
  }
}

export async function fetchJobsFromProject({ id }) {
  try {
    const query = {
      fields: ["id", "name", "project.project_id", "project.id"],
      filter: {
        project: { _eq: id },
        status: { _eq: "in_progress" },
      },
      limit: -1,
    };
    const response = await getItemsFromCollection("jobs", query);
    return response;
  } catch (error) {
    console.error("Error fetching jobs from project:", error);
    throw error;
  }
}

export async function fetchAllJobsFromProject({ id }) {
  try {
    const query = {
      fields: ["id", "name", "description", "status", "project.project_id", "project.id"],
      filter: {
        project: { _eq: id },
      },
      limit: -1,
    };
    const response = await getItemsFromCollection("jobs", query);
    return response;
  } catch (error) {
    console.error("Error fetching all jobs from project:", error);
    throw error;
  }
}

export async function fetchUserById(id) {
  try {
    const query = {
      fields: [
        "id",
        "first_name",
        "last_name",
        "title",
        "avatar",
        "email",
        "department.id",
        "department.name",
        "role.id",
        "role.name",
      ],
    };

    const response = await getItemFromCollection("directus_users", id, query);
    return response;
  } catch (error) {
    console.error("Error fetching user:", error);
    throw error;
  }
}

export async function fetchProjectClient({ id }) {
  try {
    const query = {
      fields: [
        "client",
        "client.id",
        "client.company_id.name",
        "client.first_name",
        "client.last_name",
      ],
      filter: {
        id: { _eq: id },
      },
    };
    const response = await getItemsFromCollection("projects", query);
    return response[0]?.client;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

